import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { TCCPLocalStorageService } from './tccp-local-storage.service';
import * as _ from 'lodash';
import { ExpirationDialogComponent } from '../../admin/expiration-dialog/expiration-dialog.component';
import { Utilities } from '../../shared/utilities';

@Injectable({
  providedIn: 'root'
})
export class MsalTokenInterceptorService implements HttpInterceptor {

  public isTessRoleEnabled = environment.isTessEnabled;
  private tokenExpirationTimer: any;
  private isCountdownRunning = false; // Flag to track countdown status

  constructor(
    public authService: MsalService, public router: Router,
    private dialog: MatDialog, private storageService: TCCPLocalStorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.instance.getActiveAccount() && !_.isNil(this.authService.instance.getActiveAccount().username)) {
      this.storageService.setUpn(this.authService.instance.getActiveAccount().username);
    }

    if (this.router.url.indexOf('admin') !== -1) {
      if (this.isTessRoleEnabled && !_.isNil(this.authService.instance.getActiveAccount().username)) {
        this.storageService.setRoles(this.authService.instance.getActiveAccount().idTokenClaims.roles);
        const expires_in = this.storageService.getTokenExpiry();
        if (!this.isCountdownRunning) { 
          this.checkTokenExpiration(expires_in); 
        }
      }
      if (!this.authService.instance.getActiveAccount() || !this.authService.instance.getActiveAccount().idTokenClaims.roles
        || this.authService.instance.getActiveAccount().idTokenClaims.roles.indexOf('CT-Adminsuperuser') === -1) {
        this.authService.logoutRedirect();
      }

      if (request.url.indexOf('amazonaws') === -1) {
        const { token } = JSON.parse(this.storageService.getToken());
        const expires_in = this.storageService.getTokenExpiry();
        if (!this.isCountdownRunning) { 
          this.checkTokenExpiration(expires_in); 
        }

        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        let errMsg = '';
        if (error.error instanceof ErrorEvent) {
          errMsg = `Error: ${error.error.message}`;
        } else {
          errMsg = `Error Occurred. Code: ${error.status},  Message: ${error.message}`;
        }

        return throwError(errMsg);
      })
    );
  }

  private checkTokenExpiration(expiresIn: any): void {
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer);
    }
    const jsonExpireObject = JSON.parse(expiresIn);

    // Create new expires Date object
    const expiresOnDate: Date = new Date(jsonExpireObject.expiresOn);
    let countdown = Utilities.getSecondsUntilExpiry(expiresOnDate) - 60;

    if (countdown > 0) {
      this.isCountdownRunning = true; // Set the flag to true
      this.tokenExpirationTimer = setTimeout(() => {
        const interval = setInterval(() => {
          countdown--;
          if (countdown <= 0) {
            clearInterval(interval);
            this.dialog.open(ExpirationDialogComponent, {
              width: '300px',
              data: { countdown: 60 }
            });
          }    
        }, 1000);
      }, 1000);
    }
    else {
      this.authService.logoutRedirect();
    }
  }
}
